<template>
  <div class="main_page index_page curriculum_page">
    <div class="curriculum_main" ref="middle_page">
      <span class="curriculum_page_span"></span>
      <div class="curriculumPage">
        <div class="exam_begins_box">
          <p class="examination_notes">{{this.$route.query.courseName}}&nbsp;{{$t('questionnaire.questionnaire')}}</p>
          <div v-for="(item, index) in questionnaireInfo.questionsList" :key="index">
            <div class="exam_begins_rule" v-if="item.questionUse == 1">
              <p class="exam_begins_rule_title">{{item.questionNo}}. {{item.questionContent}}</p>
              <div class="exam_begins_rule_content">
                <el-rate
                  v-model="answerList1[index]"
                  :colors="colors"
                  id="index"
                  v-if="questionnaireInfo.commitAnswerFlag == 0"
                  text-color="#ff9900"
                  show-score
                ></el-rate>
                <el-rate
                  v-model="answerList1[index]"
                  :colors="colors"
                  id="index"
                  v-if="questionnaireInfo.commitAnswerFlag > 0"
                  text-color="#ff9900"
                  show-score
                  disabled
                ></el-rate>
              </div>
            </div>
            <div class="exam_begins_rule" v-if="item.questionUse == 2">
              <p class="exam_begins_rule_title">{{item.questionNo}}. {{item.questionContent}}</p>
              <div class="exam_begins_rule_content">
                <el-radio-group v-model="answerList2[index]" v-if="questionnaireInfo.commitAnswerFlag == 0">
                  <div v-if="item.optionA != null"><el-radio :label="item.questionNo + '1'"><span style="color: #E8E6E6;">A. {{item.optionA}}</span></el-radio></div>
                  <div v-if="item.optionB != null" style="margin-top: 20px;"><el-radio :label="item.questionNo + '2'"><span style="color: #E8E6E6;">B. {{item.optionB}}</span></el-radio></div>
                  <div v-if="item.optionC != null" style="margin-top: 20px;"><el-radio :label="item.questionNo + '3'"><span style="color: #E8E6E6;">C. {{item.optionC}}</span></el-radio></div>
                  <div v-if="item.optionD != null" style="margin-top: 20px;"><el-radio :label="item.questionNo + '4'"><span style="color: #E8E6E6;">D. {{item.optionD}}</span></el-radio></div>
                  <div v-if="item.optionE != null" style="margin-top: 20px;"><el-radio :label="item.questionNo + '5'"><span style="color: #E8E6E6;">E. {{item.optionE}}</span></el-radio></div>
                  <div v-if="item.optionF != null" style="margin-top: 20px;"><el-radio :label="item.questionNo + '6'"><span style="color: #E8E6E6;">F. {{item.optionF}}</span></el-radio></div>
                  <div v-if="item.optionG != null" style="margin-top: 20px;"><el-radio :label="item.questionNo + '7'"><span style="color: #E8E6E6;">G. {{item.optionG}}</span></el-radio></div>
                  <div v-if="item.optionH != null" style="margin-top: 20px;"><el-radio :label="item.questionNo + '8'"><span style="color: #E8E6E6;">H. {{item.optionH}}</span></el-radio></div>
                  <div v-if="item.optionI != null" style="margin-top: 20px;"><el-radio :label="item.questionNo + '9'"><span style="color: #E8E6E6;">I. {{item.optionI}}</span></el-radio></div>
                  <div v-if="item.optionJ != null" style="margin-top: 20px;"><el-radio :label="item.questionNo + '0'"><span style="color: #E8E6E6;">J. {{item.optionJ}}</span></el-radio></div>
                </el-radio-group>
                <el-radio-group v-model="answerList2[index]" v-if="questionnaireInfo.commitAnswerFlag > 0">
                  <div v-if="item.optionA != null"><el-radio :label="item.questionNo + '1'" disabled><span style="color: #E8E6E6;">A. {{item.optionA}}</span></el-radio></div>
                  <div v-if="item.optionB != null" style="margin-top: 20px;"><el-radio :label="item.questionNo + '2'" disabled><span style="color: #E8E6E6;">B. {{item.optionB}}</span></el-radio></div>
                  <div v-if="item.optionC != null" style="margin-top: 20px;"><el-radio :label="item.questionNo + '3'" disabled><span style="color: #E8E6E6;">C. {{item.optionC}}</span></el-radio></div>
                  <div v-if="item.optionD != null" style="margin-top: 20px;"><el-radio :label="item.questionNo + '4'" disabled><span style="color: #E8E6E6;">D. {{item.optionD}}</span></el-radio></div>
                  <div v-if="item.optionE != null" style="margin-top: 20px;"><el-radio :label="item.questionNo + '5'" disabled><span style="color: #E8E6E6;">E. {{item.optionE}}</span></el-radio></div>
                  <div v-if="item.optionF != null" style="margin-top: 20px;"><el-radio :label="item.questionNo + '6'" disabled><span style="color: #E8E6E6;">F. {{item.optionF}}</span></el-radio></div>
                  <div v-if="item.optionG != null" style="margin-top: 20px;"><el-radio :label="item.questionNo + '7'" disabled><span style="color: #E8E6E6;">G. {{item.optionG}}</span></el-radio></div>
                  <div v-if="item.optionH != null" style="margin-top: 20px;"><el-radio :label="item.questionNo + '8'" disabled><span style="color: #E8E6E6;">H. {{item.optionH}}</span></el-radio></div>
                  <div v-if="item.optionI != null" style="margin-top: 20px;"><el-radio :label="item.questionNo + '9'" disabled><span style="color: #E8E6E6;">I. {{item.optionI}}</span></el-radio></div>
                  <div v-if="item.optionJ != null" style="margin-top: 20px;"><el-radio :label="item.questionNo + '0'" disabled><span style="color: #E8E6E6;">J. {{item.optionJ}}</span></el-radio></div>
                </el-radio-group>
              </div>
            </div>
            <div class="exam_begins_rule" v-if="item.questionUse == 3">
              <p class="exam_begins_rule_title">{{item.questionNo}}. {{item.questionContent}}</p>
              <div class="exam_begins_rule_content">
                <el-checkbox-group v-model="answerList3[index]"  v-if="questionnaireInfo.commitAnswerFlag == 0">
                  <div v-if="item.optionA != null" :id="item.questionNo + '1'"><el-checkbox :label="item.questionNo + '1'"><span style="color: #E8E6E6;">A. {{item.optionA}}</span></el-checkbox></div>
                  <div v-if="item.optionB != null" :id="item.questionNo + '2'" style="margin-top: 20px;"><el-checkbox :label="item.questionNo + '2'"><span style="color: #E8E6E6;">B. {{item.optionB}}</span></el-checkbox></div>
                  <div v-if="item.optionC != null" :id="item.questionNo + '3'" style="margin-top: 20px;"><el-checkbox :label="item.questionNo + '3'"><span style="color: #E8E6E6;">C. {{item.optionC}}</span></el-checkbox></div>
                  <div v-if="item.optionD != null" :id="item.questionNo + '4'" style="margin-top: 20px;"><el-checkbox :label="item.questionNo + '4'"><span style="color: #E8E6E6;">D. {{item.optionD}}</span></el-checkbox></div>
                  <div v-if="item.optionE != null" :id="item.questionNo + '5'" style="margin-top: 20px;"><el-checkbox :label="item.questionNo + '5'"><span style="color: #E8E6E6;">E. {{item.optionE}}</span></el-checkbox></div>
                  <div v-if="item.optionF != null" :id="item.questionNo + '6'" style="margin-top: 20px;"><el-checkbox :label="item.questionNo + '6'"><span style="color: #E8E6E6;">F. {{item.optionF}}</span></el-checkbox></div>
                  <div v-if="item.optionG != null" :id="item.questionNo + '7'" style="margin-top: 20px;"><el-checkbox :label="item.questionNo + '7'"><span style="color: #E8E6E6;">G. {{item.optionG}}</span></el-checkbox></div>
                  <div v-if="item.optionH != null" :id="item.questionNo + '8'" style="margin-top: 20px;"><el-checkbox :label="item.questionNo + '8'"><span style="color: #E8E6E6;">H. {{item.optionH}}</span></el-checkbox></div>
                  <div v-if="item.optionI != null" :id="item.questionNo + '9'" style="margin-top: 20px;"><el-checkbox :label="item.questionNo + '9'"><span style="color: #E8E6E6;">I. {{item.optionI}}</span></el-checkbox></div>
                  <div v-if="item.optionJ != null" :id="item.questionNo + '0'" style="margin-top: 20px;"><el-checkbox :label="item.questionNo + '0'"><span style="color: #E8E6E6;">J. {{item.optionJ}}</span></el-checkbox></div>
                </el-checkbox-group>
                <el-checkbox-group v-model="answerList3[index]"  v-if="questionnaireInfo.commitAnswerFlag > 0">
                  <div v-if="item.optionA != null" :id="item.questionNo + '1'"><el-checkbox :label="item.questionNo + '1'" disabled><span style="color: #E8E6E6;">A. {{item.optionA}}</span></el-checkbox></div>
                  <div v-if="item.optionB != null" :id="item.questionNo + '2'" style="margin-top: 20px;"><el-checkbox :label="item.questionNo + '2'" disabled><span style="color: #E8E6E6;">B. {{item.optionB}}</span></el-checkbox></div>
                  <div v-if="item.optionC != null" :id="item.questionNo + '3'" style="margin-top: 20px;"><el-checkbox :label="item.questionNo + '3'" disabled><span style="color: #E8E6E6;">C. {{item.optionC}}</span></el-checkbox></div>
                  <div v-if="item.optionD != null" :id="item.questionNo + '4'" style="margin-top: 20px;"><el-checkbox :label="item.questionNo + '4'" disabled><span style="color: #E8E6E6;">D. {{item.optionD}}</span></el-checkbox></div>
                  <div v-if="item.optionE != null" :id="item.questionNo + '5'" style="margin-top: 20px;"><el-checkbox :label="item.questionNo + '5'" disabled><span style="color: #E8E6E6;">E. {{item.optionE}}</span></el-checkbox></div>
                  <div v-if="item.optionF != null" :id="item.questionNo + '6'" style="margin-top: 20px;"><el-checkbox :label="item.questionNo + '6'" disabled><span style="color: #E8E6E6;">F. {{item.optionF}}</span></el-checkbox></div>
                  <div v-if="item.optionG != null" :id="item.questionNo + '7'" style="margin-top: 20px;"><el-checkbox :label="item.questionNo + '7'" disabled><span style="color: #E8E6E6;">G. {{item.optionG}}</span></el-checkbox></div>
                  <div v-if="item.optionH != null" :id="item.questionNo + '8'" style="margin-top: 20px;"><el-checkbox :label="item.questionNo + '8'" disabled><span style="color: #E8E6E6;">H. {{item.optionH}}</span></el-checkbox></div>
                  <div v-if="item.optionI != null" :id="item.questionNo + '9'" style="margin-top: 20px;"><el-checkbox :label="item.questionNo + '9'" disabled><span style="color: #E8E6E6;">I. {{item.optionI}}</span></el-checkbox></div>
                  <div v-if="item.optionJ != null" :id="item.questionNo + '0'" style="margin-top: 20px;"><el-checkbox :label="item.questionNo + '0'" disabled><span style="color: #E8E6E6;">J. {{item.optionJ}}</span></el-checkbox></div>
                </el-checkbox-group>
              </div>
            </div>

            <div class="exam_begins_rule" v-if="item.questionUse == 4">
              <p class="exam_begins_rule_title">{{item.questionNo}}. {{item.questionContent}}</p>
              <div class="exam_begins_rule_content">
                <el-input
                  type="textarea"
                  :placeholder="$t('questionnaire.contentInput')"
                  v-model="answerList4[index]"
                  maxlength="100"
                  rows="4"
                  show-word-limit
                  v-if="questionnaireInfo.commitAnswerFlag == 0"
                ></el-input>
                <el-input
                  type="textarea"
                  :placeholder="$t('questionnaire.contentInput')"
                  v-model="answerList4[index]"
                  maxlength="100"
                  rows="4"
                  show-word-limit
                  v-if="questionnaireInfo.commitAnswerFlag > 0"
                  disabled
                ></el-input>
              </div>
            </div>
          </div>
          <div class="button_box">
            <button class="exam_btn" @click="handleHintBox" v-if="questionnaireInfo.commitAnswerFlag == 0">{{$t('questionnaire.submit')}}</button>
            <button class="return" @click="goto_lesson">{{$t('common.returnButton')}}</button>
          </div>
        </div>
      </div>
    </div>
    <!-- Loading -->
    <loading :showLoading="loading" />
  </div>
</template>

<script>
import loading from "@/components/loading/loading";
export default {
  name: "exam_begins",
  data() {
    return {
      questionnaireInfo: {},
      userId: null, //用户id
      courseId: null, //课程id
      answerList1: [100],
      answerList2: [100],
      answerList3: [100],
      answerList4: [100],
      answerlist: [],
      colors: ['#99A9BF','#F7BA2A','#FF9900'],
      count: 0,
      list: [],
      loading: false
    };
  },
  components: {
    loading
  },
  mounted() {
    //获取设备屏幕的高度
    const h = document.body.clientHeight - 299;
    // this.$refs.middle_page.style.minHeight = h + "px";
    this.$autoLogin().then(
      () => {
        //设置初期值
        let i = 100;
        while (i--) {
          let list3 = [];
          this.answerList1[i] = 0;
          this.answerList2[i] = null;
          this.answerList3[i] = list3;
          this.answerList4[i] = null;
        }
        //接收参数
        this.courseId = this.$route.query.courseId;
        //登录成功
        this.userId = window.sessionStorage.getItem("id");
        this.role = window.sessionStorage.getItem("role");

        //查询用户是否作答过问卷调查题
        this.$api
          .post("/studyCourseQuestion/getQuestionnaire", {
            courseId: this.courseId,
          })
          .then((response) => {
            if (response.data != null) {
              const that = this;
              that.questionnaireInfo = response.data;
              if (that.questionnaireInfo.commitAnswerFlag > 0) {
                for (that.count = 0; that.count < that.questionnaireInfo.questionsList.length; that.count++) {
                  // (1：评价题；2：单选题；3：多选题；4：建议题)
                  if (that.questionnaireInfo.questionsList[that.count].questionUse == "1") {
                    that.answerList1[that.count] = that.questionnaireInfo.questionsList[that.count].commitAnswer;
                  }
                  if (that.questionnaireInfo.questionsList[that.count].questionUse == "2") {
                    if (that.questionnaireInfo.questionsList[that.count].commitAnswer == "A") {
                      that.answerList2[that.count] = Number(that.questionnaireInfo.questionsList[that.count].questionNo)*10 + 1 + "";
                    }
                    if (that.questionnaireInfo.questionsList[that.count].commitAnswer == "B") {
                      that.answerList2[that.count] = Number(that.questionnaireInfo.questionsList[that.count].questionNo)*10 + 2 + "";
                    }
                    if (that.questionnaireInfo.questionsList[that.count].commitAnswer == "C") {
                      that.answerList2[that.count] = Number(that.questionnaireInfo.questionsList[that.count].questionNo)*10 + 3 + "";
                    }
                    if (that.questionnaireInfo.questionsList[that.count].commitAnswer == "D") {
                      that.answerList2[that.count] = Number(that.questionnaireInfo.questionsList[that.count].questionNo)*10 + 4 + "";
                    }
                    if (that.questionnaireInfo.questionsList[that.count].commitAnswer == "E") {
                      that.answerList2[that.count] = Number(that.questionnaireInfo.questionsList[that.count].questionNo)*10 + 5 + "";
                    }
                    if (that.questionnaireInfo.questionsList[that.count].commitAnswer == "F") {
                      that.answerList2[that.count] = Number(that.questionnaireInfo.questionsList[that.count].questionNo)*10 + 6 + "";
                    }
                    if (that.questionnaireInfo.questionsList[that.count].commitAnswer == "G") {
                      that.answerList2[that.count] = Number(that.questionnaireInfo.questionsList[that.count].questionNo)*10 + 7 + "";
                    }
                    if (that.questionnaireInfo.questionsList[that.count].commitAnswer == "H") {
                      that.answerList2[that.count] = Number(that.questionnaireInfo.questionsList[that.count].questionNo)*10 + 8 + "";
                    }
                    if (that.questionnaireInfo.questionsList[that.count].commitAnswer == "I") {
                      that.answerList2[that.count] = Number(that.questionnaireInfo.questionsList[that.count].questionNo)*10 + 9 + "";
                    }
                    if (that.questionnaireInfo.questionsList[that.count].commitAnswer == "J") {
                      that.answerList2[that.count] = Number(that.questionnaireInfo.questionsList[that.count].questionNo)*10 + "";
                    }
                  }
                  if (that.questionnaireInfo.questionsList[that.count].questionUse == "3") {
                    let s = that.questionnaireInfo.questionsList[that.count].commitAnswer.split(",")
                    for (var t = 0; t < s.length; t++) {
                      if (s[t] == "A") {
                        that.answerList3[that.count].push(Number(that.questionnaireInfo.questionsList[that.count].questionNo)*10 + 1 + "");
                      }
                      if (s[t] == "B") {
                        that.answerList3[that.count].push(Number(that.questionnaireInfo.questionsList[that.count].questionNo)*10 + 2 + "");
                      }
                      if (s[t] == "C") {
                        that.answerList3[that.count].push(Number(that.questionnaireInfo.questionsList[that.count].questionNo)*10 + 3 + "");
                      }
                      if (s[t] == "D") {
                        that.answerList3[that.count].push(Number(that.questionnaireInfo.questionsList[that.count].questionNo)*10 + 4 + "");
                      }
                      if (s[t] == "E") {
                        that.answerList3[that.count].push(Number(that.questionnaireInfo.questionsList[that.count].questionNo)*10 + 5 + "");
                      }
                      if (s[t] == "F") {
                        that.answerList3[that.count].push(Number(that.questionnaireInfo.questionsList[that.count].questionNo)*10 + 6 + "");
                      }
                      if (s[t] == "G") {
                        that.answerList3[that.count].push(Number(that.questionnaireInfo.questionsList[that.count].questionNo)*10 + 7 + "");
                      }
                      if (s[t] == "H") {
                        that.answerList3[that.count].push(Number(that.questionnaireInfo.questionsList[that.count].questionNo)*10 + 8 + "");
                      }
                      if (s[t] == "I") {
                        that.answerList3[that.count].push(Number(that.questionnaireInfo.questionsList[that.count].questionNo)*10 + 9 + "");
                      }
                      if (s[t] == "J") {
                        that.answerList3[that.count].push(Number(that.questionnaireInfo.questionsList[that.count].questionNo)*10 + "");
                      }
                    }
                  }
                  if (that.questionnaireInfo.questionsList[that.count].questionUse == "4") {
                    that.answerList4[that.count] = that.questionnaireInfo.questionsList[that.count].commitAnswer;
                  }
                }
              }
            }
          });
      },
      () => {
        //未登录跳回首页
        this.$router.push({
          path: "/home",
        });
      }
    );
  },
  methods: {
    goto_lesson: function () {
      let outlineInfo = {
        courseId: this.$route.query.courseId,
        courseName: this.$route.query.courseName,
      };
      this.$router.push({
        path: "/home/curriculum",
        query: {
          outlineInfo: JSON.stringify(outlineInfo),
        },
      });
    },
    //用户提交问卷调查题答案
    commit_answer: function () {
      this.lists = [];
      for (this.count = 0; this.count < this.questionnaireInfo.questionsList.length; this.count++) {
        let commitAnswer = "";
        let abc = ["","","","","","","","","",""];
        // (1：评价题；2：单选题；3：多选题；4：建议题)
        if (this.questionnaireInfo.questionsList[this.count].questionUse == "1") {
          commitAnswer = this.answerList1[this.count];
        }
        if (this.questionnaireInfo.questionsList[this.count].questionUse == "2") {
          if (Number(this.answerList2[this.count])%10 === 1) {
            commitAnswer = "A";
          }
          if (Number(this.answerList2[this.count])%10 === 2) {
            commitAnswer = "B";
          }
          if (Number(this.answerList2[this.count])%10 === 3) {
            commitAnswer = "C";
          }
          if (Number(this.answerList2[this.count])%10 === 4) {
            commitAnswer = "D";
          }
          if (Number(this.answerList2[this.count])%10 === 5) {
            commitAnswer = "E";
          }
          if (Number(this.answerList2[this.count])%10 === 6) {
            commitAnswer = "F";
          }
          if (Number(this.answerList2[this.count])%10 === 7) {
            commitAnswer = "G";
          }
          if (Number(this.answerList2[this.count])%10 === 8) {
            commitAnswer = "H";
          }
          if (Number(this.answerList2[this.count])%10 === 9) {
            commitAnswer = "I";
          }
          if (Number(this.answerList2[this.count])%10 === 0) {
            commitAnswer = "J";
          }
        }
        if (this.questionnaireInfo.questionsList[this.count].questionUse == "3") {
          let str = "";
          let strOption = "";
          for (var k = 0; k < this.answerList3[this.count].length; k++) {
            if (Number(this.answerList3[this.count][k]%10 === 1)) {
              abc[0] = "A";
            }
            if (Number(this.answerList3[this.count][k]%10 === 2)) {
              abc[1] = "B";
            }
            if (Number(this.answerList3[this.count][k]%10 === 3)) {
              abc[2] = "C";
            }
            if (Number(this.answerList3[this.count][k]%10 === 4)) {
              abc[3] = "D";
            }
            if (Number(this.answerList3[this.count][k]%10 === 5)) {
              abc[4] = "E";
            }
            if (Number(this.answerList3[this.count][k]%10 === 6)) {
              abc[5] = "F";
            }
            if (Number(this.answerList3[this.count][k]%10 === 7)) {
              abc[6] = "G";
            }
            if (Number(this.answerList3[this.count][k]%10 === 8)) {
              abc[7] = "H";
            }
            if (Number(this.answerList3[this.count][k]%10 === 9)) {
              abc[8] = "I";
            }
            if (Number(this.answerList3[this.count][k]%10 === 0)) {
              abc[9] = "J";
            }
          }
          for (var m = 0; m < abc.length; m++) {
            if (abc[m] != "") {
              if (m == 0 || commitAnswer == "") {
                commitAnswer = commitAnswer + abc[m]
              } else {
                commitAnswer = commitAnswer + "," + abc[m]
              }
            }

          }
        }
        if (this.questionnaireInfo.questionsList[this.count].questionUse == "4") {
          commitAnswer = this.answerList4[this.count];
        }

        let list = {
          courseId: this.courseId,
          questionId: this.questionnaireInfo.questionnaireId,
          questionNo: this.questionnaireInfo.questionsList[this.count].questionNo,
          commitAnswer: commitAnswer,
        };
        this.lists.push(list);
      }
      this.$api
          .post("/studyCourseQuestion/commitQuestionnaire", {commitQuestionnaireList: this.lists})
          .then((response) => {
            let outlineInfo = {
              courseId: this.$route.query.courseId,
              courseName: this.$route.query.courseName,
            };
            this.$router.push({
              path: "/home/curriculum",
              query: {
                outlineInfo: JSON.stringify(outlineInfo),
              },
            });
            this.loading = false;
          });
    },
    handleHintBox: function () {
      this.count = 0;
      for (this.count = 0; this.count < this.questionnaireInfo.questionsList.length; this.count++) {
        // (1：评价题；2：单选题；3：多选题；4：建议题)
        if (this.questionnaireInfo.questionsList[this.count].questionUse == "1") {
          if (this.answerList1[this.count] === 0) {
            this.$alert(window.vm.$i18n.t("js.nonull"), "", {confirmButtonText: window.vm.$i18n.t("js.confirm"),});
            return;
          }
        }
        if (this.questionnaireInfo.questionsList[this.count].questionUse == "2") {
          if (this.questionnaireInfo.questionsList[this.count].optionA != null && this.answerList2[this.count][0] === undefined && this.answerList2[this.count][0] === null && this.answerList2[this.count][0] === "") {
            this.$alert(window.vm.$i18n.t("js.nonull"), "", {confirmButtonText: window.vm.$i18n.t("js.confirm"),});
            return;
          }
          if (this.questionnaireInfo.questionsList[this.count].optionB != null && this.answerList2[this.count][1] === undefined && this.answerList2[this.count][1] === null && this.answerList2[this.count][1] === "") {
            this.$alert(window.vm.$i18n.t("js.nonull"), "", {confirmButtonText: window.vm.$i18n.t("js.confirm"),});
            return;
          }
          if (this.questionnaireInfo.questionsList[this.count].optionC != null && this.answerList2[this.count][2] === undefined && this.answerList2[this.count][2] === null && this.answerList2[this.count][2] === "") {
            this.$alert(window.vm.$i18n.t("js.nonull"), "", {confirmButtonText: window.vm.$i18n.t("js.confirm"),});
            return;
          }
          if (this.questionnaireInfo.questionsList[this.count].optionD != null && this.answerList2[this.count][3] === undefined && this.answerList2[this.count][3] === null && this.answerList2[this.count][3] === "") {
            this.$alert(window.vm.$i18n.t("js.nonull"), "", {confirmButtonText: window.vm.$i18n.t("js.confirm"),});
            return;
          }
          if (this.questionnaireInfo.questionsList[this.count].optionE != null && this.answerList2[this.count][4] === undefined && this.answerList2[this.count][4] === null && this.answerList2[this.count][4] === "") {
            this.$alert(window.vm.$i18n.t("js.nonull"), "", {confirmButtonText: window.vm.$i18n.t("js.confirm"),});
            return;
          }
          if (this.questionnaireInfo.questionsList[this.count].optionF != null && this.answerList2[this.count][5] === undefined && this.answerList2[this.count][5] === null && this.answerList2[this.count][5] === "") {
            this.$alert(window.vm.$i18n.t("js.nonull"), "", {confirmButtonText: window.vm.$i18n.t("js.confirm"),});
            return;
          }
          if (this.questionnaireInfo.questionsList[this.count].optionG != null && this.answerList2[this.count][6] === undefined && this.answerList2[this.count][6] === null && this.answerList2[this.count][6] === "") {
            this.$alert(window.vm.$i18n.t("js.nonull"), "", {confirmButtonText: window.vm.$i18n.t("js.confirm"),});
            return;
          }
          if (this.questionnaireInfo.questionsList[this.count].optionH != null && this.answerList2[this.count][7] === undefined && this.answerList2[this.count][7] === null && this.answerList2[this.count][7] === "") {
            this.$alert(window.vm.$i18n.t("js.nonull"), "", {confirmButtonText: window.vm.$i18n.t("js.confirm"),});
            return;
          }
          if (this.questionnaireInfo.questionsList[this.count].optionI != null && this.answerList2[this.count][7] === undefined && this.answerList2[this.count][7] === null && this.answerList2[this.count][7] === "") {
            this.$alert(window.vm.$i18n.t("js.nonull"), "", {confirmButtonText: window.vm.$i18n.t("js.confirm"),});
            return;
          }
          if (this.questionnaireInfo.questionsList[this.count].optionJ != null && this.answerList2[this.count][9] === undefined && this.answerList2[this.count][9] === null && this.answerList2[this.count][9] === "") {
            this.$alert(window.vm.$i18n.t("js.nonull"), "", {confirmButtonText: window.vm.$i18n.t("js.confirm"),});
            return;
          }
        }
        if (this.questionnaireInfo.questionsList[this.count].questionUse == "3") {
          if (this.questionnaireInfo.questionsList[this.count].optionA != null && this.answerList3[this.count] === undefined && this.answerList3[this.count] === null && this.answerList3[this.count] === "") {
            this.$alert(window.vm.$i18n.t("js.nonull"), "", {confirmButtonText: window.vm.$i18n.t("js.confirm"),});
            return;
          }
          if (this.questionnaireInfo.questionsList[this.count].optionB != null && this.answerList3[this.count] === undefined && this.answerList3[this.count] === null && this.answerList3[this.count] === "") {
            this.$alert(window.vm.$i18n.t("js.nonull"), "", {confirmButtonText: window.vm.$i18n.t("js.confirm"),});
            return;
          }
          if (this.questionnaireInfo.questionsList[this.count].optionC != null && this.answerList3[this.count] === undefined && this.answerList3[this.count] === null && this.answerList3[this.count] === "") {
            this.$alert(window.vm.$i18n.t("js.nonull"), "", {confirmButtonText: window.vm.$i18n.t("js.confirm"),});
            return;
          }
          if (this.questionnaireInfo.questionsList[this.count].optionD != null && this.answerList3[this.count] === undefined && this.answerList3[this.count] === null && this.answerList3[this.count] === "") {
            this.$alert(window.vm.$i18n.t("js.nonull"), "", {confirmButtonText: window.vm.$i18n.t("js.confirm"),});
            return;
          }
          if (this.questionnaireInfo.questionsList[this.count].optionE != null && this.answerList3[this.count] === undefined && this.answerList3[this.count] === null && this.answerList3[this.count] === "") {
            this.$alert(window.vm.$i18n.t("js.nonull"), "", {confirmButtonText: window.vm.$i18n.t("js.confirm"),});
            return;
          }
          if (this.questionnaireInfo.questionsList[this.count].optionF != null && this.answerList3[this.count] === undefined && this.answerList3[this.count] === null && this.answerList3[this.count] === "") {
            this.$alert(window.vm.$i18n.t("js.nonull"), "", {confirmButtonText: window.vm.$i18n.t("js.confirm"),});
            return;
          }
          if (this.questionnaireInfo.questionsList[this.count].optionG != null && this.answerList3[this.count] === undefined && this.answerList3[this.count] === null && this.answerList3[this.count] === "") {
            this.$alert(window.vm.$i18n.t("js.nonull"), "", {confirmButtonText: window.vm.$i18n.t("js.confirm"),});
            return;
          }
          if (this.questionnaireInfo.questionsList[this.count].optionH != null && this.answerList3[this.count] === undefined && this.answerList3[this.count] === null && this.answerList3[this.count] === "") {
            this.$alert(window.vm.$i18n.t("js.nonull"), "", {confirmButtonText: window.vm.$i18n.t("js.confirm"),});
            return;
          }
          if (this.questionnaireInfo.questionsList[this.count].optionI != null && this.answerList3[this.count] === undefined && this.answerList3[this.count] === null && this.answerList3[this.count] === "") {
            this.$alert(window.vm.$i18n.t("js.nonull"), "", {confirmButtonText: window.vm.$i18n.t("js.confirm"),});
            return;
          }
          if (this.questionnaireInfo.questionsList[this.count].optionJ != null && this.answerList3[this.count] === undefined && this.answerList3[this.count] === null && this.answerList3[this.count] === "") {
            this.$alert(window.vm.$i18n.t("js.nonull"), "", {confirmButtonText: window.vm.$i18n.t("js.confirm"),});
            return;
          }
        }
        if (this.questionnaireInfo.questionsList[this.count].questionUse == "4") {
          if (this.answerList4[this.count] === undefined || this.answerList4[this.count] === null || this.answerList4[this.count].replace(/^\s+|\s+$/gm, '') === "") {
            this.$alert(window.vm.$i18n.t("js.nonull"), "", {confirmButtonText: window.vm.$i18n.t("js.confirm"),});
            return;
          }
        }
      }

      this.$confirm(
        window.vm.$i18n.t("js.submitHint"),
        window.vm.$i18n.t("js.hint"),
        {
          confirmButtonText: window.vm.$i18n.t("js.confirm"),
          cancelButtonText: window.vm.$i18n.t("js.cancel"),
          cancelButtonClass: "btn-custom-cancel"
        }
      ).then(() => {
          this.loading = true;
          this.commit_answer();
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped="scoped">
@import "../../../static/css/exam.css";

.exam_begins_box {
  width: 60%;
  height: 100%;
  padding: 30px;
  border-radius: 15px;
  margin: 80px auto;
  background-color: rgba(0, 0, 0, 0.3);
  box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.3);
  position: relative;
}

.examination_notes {
  height: 20px;
  font-size: 20px;
  color: #e8e6e6;
  text-align: center;
  font-family: source-han-sans-simplified-c, sans-serif;
  font-weight: 200;
  font-style: normal;
}

.exam_begins_box .exam_begins_rule {
  position: relative;
  /*display: -webkit-flex;*/
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px #414141 solid;
}

.exam_begins_rule .exam_begins_rule_title {
  width: auto;
  height: 20px;
  margin-right: 10px;
  font-size: 14px;
  color: #e8e6e6;
  font-family: source-han-sans-simplified-c, sans-serif;
  font-weight: 200;
  font-style: normal;
}

.exam_begins_rule .exam_begins_rule_content {
  padding-top: 20px;
  padding-left: 20px;
  max-width: 520px;
  min-height: 20px;
  position: relative;
  display: block;
}

.exam_begins_rule .exam_begins_rule_content p {
  min-height: 20px;
  line-height: 20px;
  display: flex;
  font-size: 14px;
  color: #e8e6e6;
  text-align: left;
  font-family: source-han-sans-simplified-c, sans-serif;
  font-weight: 200;
  font-style: normal;
}
.button_box {
  text-align: center;
}

.exam_btn {
  margin: 0 auto;
  margin-top: 40px;
  display: inline-block;
  text-align: center;
  font-size: 12px;
  color: #e8e6e6;
  background-color: unset;
  padding: 4px 10px 6px 10px;
  border: 1px solid #e8e6e6;
  border-radius: 20px;
  font-family: source-han-sans-simplified-c, sans-serif;
  font-weight: 200;
  font-style: normal;
  transition: 0.5s ease;
}
.return {
  margin-top: 40px;
  margin-left: 60px;
  display: inline-block;
  text-align: center;
  font-size: 12px;
  color: #e8e6e6;
  background-color: unset;
  padding: 4px 10px 6px 10px;
  border: 1px solid #e8e6e6;
  border-radius: 20px;
  font-family: source-han-sans-simplified-c, sans-serif;
  font-weight: 200;
  font-style: normal;
  transition: 0.5s ease;
}

.exam_btn:hover {
  color: #000;
  background-color: #fff;
  transition: 0.5s ease;
}
.return:hover {
  color: #000;
  background-color: #fff;
  transition: 0.5s ease;
}
.curriculum_page {
  width: 100%;
  background-image: url(../../../static/images/bg/personset_bg.jpg);
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  display: flex;
}

.curriculum_main {
  background-color: rgba(65, 65, 65, 0.5);
  width: 100%;
  height: 100%;
  min-height: 600px;
  padding-bottom: 50px;
}

.curriculum_page_span {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: alac(100% - 19px);
  background-color: rgba(0, 0, 0, 0.3);
}

.curriculumPage {
  /*width: 1024px;*/
  margin: 0 auto;
  padding-top: 140px;
  position: relative;
}

.curriculumPage .page_title {
  height: 30px;
  line-height: 30px;
  font-size: 30px;
  color: #fafafa;
  /* font-family: lato-light, lato, sans-serif;
        font-weight: 400; */
  font-family: lato, sans-serif;
  font-weight: 300;
  font-style: normal;
}
.curriculum_components {
  width: 680px;
  min-height: 200px;
  position: relative;
  margin-top: 40px;
  float: right;
  margin-left: 100px;
  right: 50px;
}
@media screen and (max-width: 1024px) {
  .curriculumPage {
    width: 94%;
    padding: 3%;
  }
  .exam_begins_box {
    width: 90%;
    padding: 30px 5%;
  }
}
</style>
<style>
  .btn-custom-cancel {
    float: right;
    margin-left: 10px;
    margin-top: 2px;
  }
  .el-checkbox__inner {
    border-radius: 0% !important;
  }
</style>


// WEBPACK FOOTER //
// src/views/exam/questionnaire.vue